import React from "react";
import { Container, Paper } from "@material-ui/core";
import Notes from "../components/Notes";

export default function NotesPage() {
  return (
    <Container maxWidth="md">
      <Paper>
        <Notes />
      </Paper>
    </Container>
  );
}
